import styled from "@emotion/styled";
import { TypedSearchResultDataValue } from "./../utils";
import { getIcon } from "./../icon-factory";
import { Typography } from "@kaltura/ds-react-components";

export interface SimpleSearchResultProps {
    data: TypedSearchResultDataValue;
}

const StyledSimpleSearchResult = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 0),
    alignItems: "center",
}));

const StyledTypography = styled(Typography)({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
});

export function SimpleSearchResult({ data }: SimpleSearchResultProps) {
    const icon = getIcon(data.type);
    return (
        <StyledSimpleSearchResult>
            {icon}
            <StyledTypography variant={"body2"}>{data.text}</StyledTypography>
        </StyledSimpleSearchResult>
    );
}

export default SimpleSearchResult;
